import { useState } from 'react';

import { CONNECTOR_LOGOS } from '~/components/logos/connector-logos';
import { cn } from '~/utils/cn';

import { getConnectionTypeInitials } from '../utils/connection-display';

interface ConnectorIconProps {
  /** Connection/connector type code (e.g. `GA4_REPORTING`). */
  type: string;
  /** Remote icon URL used only when no bundled logo matches the type. */
  iconUrl?: string | null | undefined;
  /** Overrides sizing/spacing on the rendered mark (default 8×8). */
  className?: string;
}

/**
 * Brand mark for a connection: a bundled channel logo when the type is known,
 * else the connector's remote `iconUrl`, else an initials tile so unknown
 * connectors still read clearly.
 */
export function ConnectorIcon({ type, iconUrl, className }: ConnectorIconProps) {
  const [failed, setFailed] = useState(false);
  const Logo = CONNECTOR_LOGOS[type];

  if (Logo) return <Logo className={cn('h-8 w-8 shrink-0', className)} />;

  if (iconUrl && !failed) {
    return (
      <img
        src={iconUrl}
        alt=""
        className={cn('h-8 w-8 shrink-0 rounded-md object-contain', className)}
        onError={() => {
          setFailed(true);
        }}
      />
    );
  }

  return (
    <span
      className={cn(
        'bg-muted text-muted-foreground flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-xs font-semibold',
        className,
      )}
    >
      {getConnectionTypeInitials(type)}
    </span>
  );
}
